import { compose } from 'ramda';
import { createAction } from 'redux-actions';

import { SERIES_FETCHED } from 'app/features/series/actionTypes';

const seriesFetched = createAction(SERIES_FETCHED);

const fetchSeries =
  () =>
  (dispatch, getState, { api }) =>
    api.fetchSeries().then(compose(dispatch, seriesFetched));

export { fetchSeries, seriesFetched };
